import { useState } from 'react'

import { InteractionType } from '@azure/msal-browser'
import type { MsalAuthenticationResult } from '@azure/msal-react'
import { LoaderCircle } from 'lucide-react'

export function AuthLoading() {
  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-6"
      aria-label="Signing in"
    >
      <LoaderCircle
        aria-hidden="true"
        className="size-8 motion-safe:animate-spin"
      />
      <p role="status">Signing in to Stagehand…</p>
    </main>
  )
}

export function AuthError({ error, login }: MsalAuthenticationResult) {
  const [retryError, setRetryError] = useState<string>()
  const [isRetrying, setIsRetrying] = useState(false)
  async function retry() {
    setIsRetrying(true)
    setRetryError(undefined)
    try {
      await login(InteractionType.Redirect)
    } catch (cause) {
      setRetryError(
        cause instanceof Error ? cause.message : 'Please try signing in again.',
      )
    } finally {
      setIsRetrying(false)
    }
  }
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <h1>We couldn’t sign you in</h1>
      <p role="alert">
        {retryError ?? error?.message ?? 'Please try signing in again.'}
      </p>
      <button
        className="btn min-h-11"
        type="button"
        disabled={isRetrying}
        onClick={() => void retry()}
      >
        {isRetrying ? 'Signing in…' : 'Try again'}
      </button>
    </main>
  )
}
